


module.exports = {
  admin: {
    adduser: '創建用戶',
    refresh: '刷新',
    useState: '使用情況',
    errorState: '異常',
    successState: '正常',
    isLocked: '是否鎖定',
    locked: '鎖定',
    unlocked: '未鎖定',
    jiesuo: '解鎖',
    nicknamePlaceholder: '請輸入用戶名查詢',
    mobilePlaceholder: '請輸入手機號查詢',
    exportData: '導出數據',
    remarkPlaceholder: '請輸入備註查詢',
    hospitalIdText: '所屬渠道',
    allHospital: '所有渠道',
    address: '地址',
    name: '用戶名',
    gender: '性別',
    mobile: '手機號',
    birthday: '生日',
    activatedAt: '激活日期',
    endDate: '結束日期',
    actions: '操作',
    remark: '備註',
    back: '返回',
    shutdonw: '關機',
    edit: '編輯',
    mechinePassword: '登錄密碼',
    information: '用戶信息',
    moreActions: '更多操作',
    submit: '確定',
    cancel: '取消',
    close: '關閉',
    nicknameText: '請填寫用戶名',
    mobileText: '請填寫手機號',
    hospitalIdRequiredText: '請選擇所屬渠道',
    operationSuccessText: '操作成功!',
    operationFailText: '操作失敗!',
    card_passwordText: '請輸入登錄密碼',
    confictMobileText: '手機號沖突',
    lockedText: "鎖定後此用戶將不會收到使用情況提醒，是否繼續？",
    unlockedText: "解鎖後此用戶將會收到使用情況提醒，是否繼續？",
    viewRecordsDialog: '查看使用數據',
    totalRecords: '使用總次',
    no: '序號',
    Date: '日期',
    UseTime: '使用時間',
    noData: '暫無數據',
    Coordination: '配合度',
    infoText1: '點擊具體日期查看使用次數',
    redText: '紅點——未使用',
    greenText: '綠點——使用兩次',
    yellowText: '黃點——使用壹次',
    infoText2: '當天的使用記錄需要隔天才能顯示',
  },
  index: {},
  server: {}
}